var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "k-toolbar", class: _vm.classes },
    [
      _c(
        "div",
        { staticClass: "k-toolbar-left" },
        [
          !_vm.removeNavIcon
            ? _c(
                "div",
                { staticClass: "k-toolbar-nav-icon" },
                [
                  _vm._t("icon", function () {
                    return [
                      _c("UiIconButton", {
                        attrs: {
                          size: "large",
                          type: "secondary",
                          color: _vm.textColor,
                          icon: _vm.navIcon,
                        },
                        on: { click: _vm.navIconClick },
                      }),
                    ]
                  }),
                ],
                2
              )
            : _vm._e(),
          _vm.brand || _vm.$slots.brand
            ? _c(
                "div",
                { staticClass: "k-toolbar-brand" },
                [
                  _vm._t("brand", function () {
                    return [
                      _c("div", { staticClass: "k-toolbar-brand-text" }, [
                        _vm._v(
                          "\n          " + _vm._s(_vm.brand) + "\n        "
                        ),
                      ]),
                    ]
                  }),
                ],
                2
              )
            : _vm._e(),
          _vm._t("default", function () {
            return [
              _vm.title
                ? _c("div", { staticClass: "k-toolbar-title" }, [
                    _vm._v("\n        " + _vm._s(_vm.title) + "\n      "),
                  ])
                : _vm._e(),
            ]
          }),
          _vm._t("navigation"),
        ],
        2
      ),
      _c("div", { staticClass: "k-toolbar-right" }, [_vm._t("actions")], 2),
      _c("UiProgressLinear", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "k-toolbar-progress",
        attrs: { color: _vm.progressColor },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }